import {useCallback, useEffect, useRef, useState} from 'react'
import {Grid} from '@mui/material'
import {
  StyledDivContainer,
  StyledPaper,
  StyledSpan,
  StyledTitleTypography,
  StyledTypography
} from '../../AskGPViewsStyles'
import config from '../../../../../../configs/askGPChatViewConfig.json'

const WelcomeTiles = () => {
  const [maxHeight, setMaxHeight] = useState(0)
  const paperRefs = useRef([])

  const adjustContainerHeight = useCallback(() => {
    const containerHeight = paperRefs.current.map((ref) => ref?.clientHeight || 0)
    const max = Math.max(...containerHeight)
    setMaxHeight(max)
  }, [])

  useEffect(() => {
    const handleResize = () => {
      adjustContainerHeight()
    }
    window.addEventListener('resize', handleResize)
    adjustContainerHeight()
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [adjustContainerHeight])

  return (
    <StyledDivContainer>
      <StyledTypography>
        Let me help you <StyledSpan>segment </StyledSpan>
        <StyledSpan>and filter</StyledSpan> your portfolio.
      </StyledTypography>
      <Grid container spacing={2} sx={{marginTop: '15px'}}>
        {config.tiles.map((tile) => (
          <Grid item xs={12} sm={4} md={4} lg={4} xl={4} key={tile.index}>
            <StyledPaper sx={{height: `${maxHeight}px`}}>
              <div ref={(el) => (paperRefs.current[tile.index] = el)} style={{padding: '3%'}}>
                <StyledTitleTypography customFontWeight={700} customFontSize={20}>
                  {tile.title}
                </StyledTitleTypography>
                <StyledTitleTypography customFontWeight={400} customFontSize={16}>
                  {tile.label}
                </StyledTitleTypography>
              </div>
            </StyledPaper>
          </Grid>
        ))}
      </Grid>
    </StyledDivContainer>
  )
}

export default WelcomeTiles
